import { render, staticRenderFns } from "./NeuroButton.vue?vue&type=template&id=f5b8466a&scoped=true&"
import script from "./NeuroButton.vue?vue&type=script&lang=js&"
export * from "./NeuroButton.vue?vue&type=script&lang=js&"
import style0 from "./NeuroButton.vue?vue&type=style&index=0&id=f5b8466a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.registry.npmjs.org/vue-loader/15.9.7_css-loader@3.6.0+webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b8466a",
  null
  
)

export default component.exports